import { StateCreator } from 'zustand';

export interface MapInfoSlice {
  bounds: any;
  setBounds: (val: any) => void;

  mapName: string;
  setMapName: (val: string) => void;

  mapDescription: string;
  setMapDescription: (val: string) => void;

  mapKeywords: string[];
  setMapKeywords: (val: string[]) => void;

  mapID: string;
  setMapID: (val: string) => void;

  URLArr: string[];
  setURLArr: (val: string[]) => void;

  isStatic: boolean | null;
  setIsStatic: (val: boolean) => void;

  initializeMapInfo: (data: { name: string; description: string; keywords: string[] }) => void;
}

// --- Initial state for easy reset --- (excluding functions)
export const mapInfoInitialState: Omit<
  MapInfoSlice,
  | 'setBounds'
  | 'setMapName'
  | 'setMapDescription'
  | 'setMapKeywords'
  | 'setMapID'
  | 'setURLArr'
  | 'setIsStatic'
  | 'initializeMapInfo'
> = {
  bounds: null,
  mapName: '',
  mapDescription: '',
  mapKeywords: [],
  mapID: '',
  URLArr: [],
  isStatic: null,
};

export const createMapInfoSlice: StateCreator<MapInfoSlice> = (set) => ({
  ...mapInfoInitialState,

  setBounds: (val) => set({ bounds: val }),
  setMapName: (val) => set({ mapName: val }),
  setMapDescription: (val) => set({ mapDescription: val }),
  setMapKeywords: (val) => set({ mapKeywords: val }),
  setMapID: (val) => set({ mapID: val }),
  setURLArr: (val) => set({ URLArr: val }),
  setIsStatic: (val) => set({ isStatic: val }),

  initializeMapInfo: ({ name, description, keywords }) =>
    set({
      mapName: name,
      mapDescription: description,
      mapKeywords: keywords,
    }),
});
